module.exports = "/_next/static/images/EmbraceGoodData@2x-12daf605eaa87dd1e082170b19b1c1c3.png";